/* eslint-disable import/order */
import React from 'react';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import type CompassProductSettingsType from '@jira/spa-apps__compass-product-settings/src/CompassProductSettingsSPAContainer.tsx';
import { compassProductSettingsResource } from '@jira/router-resources__compass-product-settings/src/useCompassProductSettingsResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { compassProductSettingsRoute } from '@jira/router-routes__compass-product-settings-routes/src/compassProductSettingsRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyCompassProductSettingsPage = lazyForPaint<typeof CompassProductSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-compass-product-settings", jiraSpaEntry: "async-compass-product-settings" */ '@jira/spa-apps__compass-product-settings/src/CompassProductSettingsSPAContainer.tsx'
		),
	),
);

const CompassProductSettingsComponent = () => (
	<LazyPage
		Page={LazyCompassProductSettingsPage}
		pageId="async-compass-product-settings"
		shouldShowSpinner
	/>
);

export const compassProductSettingsRouteEntry: Route = createEntry(
	compassProductSettingsRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: CompassProductSettingsComponent,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			compassProductSettingsResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyCompassProductSettingsPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
